import { render } from "./MobileBlogPosts.vue?vue&type=template&id=e72c0268&scoped=true"
import script from "./MobileBlogPosts.vue?vue&type=script&lang=js"
export * from "./MobileBlogPosts.vue?vue&type=script&lang=js"

import "./MobileBlogPosts.vue?vue&type=style&index=0&id=e72c0268&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72c0268"]])

export default __exports__